/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandUnsplash = createReactComponent("brand-unsplash", "IconBrandUnsplash", [
  ["path", { d: "M4 11h5v4h6v-4h5v9h-16zm5 -7h6v4h-6z", key: "svg-0" }]
]);

export { IconBrandUnsplash as default };
//# sourceMappingURL=IconBrandUnsplash.js.map
